<div class="d-flex content-methodology">
  <div class="content-left px-4 px-xxl-5 d-none d-lg-flex justify-content-center">
    <mat-vertical-stepper [linear]="false" #stepper [selectedIndex]="currentIndex"
    (selectionChange)="goToStep($event)">
      <ng-template matStepperIcon="number" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-container *ngFor="let item of methodologies">
        <mat-step>
          <ng-template matStepLabel>
            <span class="fw-light fs-6 text-step">{{item.title}}</span>
          </ng-template>
        </mat-step>
      </ng-container>
    </mat-vertical-stepper>
  </div>
  <div class="content-right h-100 pe-4 pe-xxl-5">
    <div class="d-flex gap-3 py-4 py-lg-0 content-title-step px-4 px-lg-0 align-items-center align-items-lg-start">
      <h1 class="fs-1 number-title-step fw-extrabold number mb-0">{{ currentIndex+1 }}</h1>
      <h2 class="text-title-step fs-1 fw-bold text-blue mb-0">{{ methodologySelected?.title }}</h2>
    </div>
    <div class="separator mt-3 d-none d-lg-block"></div>
    <div class="mt-0 mt-lg-5 px-4 px-lg-0 pt-4 pt-lg-0">
      <div class="content-methodology-description">
        <p class="fw-light text-blue text-description-step">{{ methodologySelected?.description }}</p>
      </div>
      <div class="content-methodology-image p-4 mt-5 mx-auto mx-md-0">
        <img [src]="methodologySelected?.image" alt="logo" class="w-100">
      </div>
    </div>
    <div class="d-flex gap-3 mt-4 px-4 px-lg-0 justify-content-center justify-content-md-start">
      <img src="assets/svg/icon-arrow-left.svg" alt="logo" width="44" class="pointer" (click)="goToPrevious()"
        [class.disabled-btn]="isFirst">
      <img src="assets/svg/icon-arrow-right.svg" alt="logo" width="44" class="pointer" (click)="goToNext()"
        [class.disabled-btn]="isLast">
    </div>
    <div class="trazo d-none d-lg-block">
      <img src="assets/svg/Trazad.svg" alt="trazo">
    </div>
  </div>
</div>
